import SlLogo from '../img/SocietyLibraryLogo-WithTitle.png'


export default function NavBar() {


    return <nav className="navbar navbar-expand-lg bg-white">
        <div className="container-fluid">
            {/* <a className="navbar-brand" href="/"> */}
            <div>
                <img src={SlLogo} alt="Society Library logo" style={{ height: "4em" }} />
                <h2 style={{ display: "inline-block" }}>Send It to the Society Library</h2>
            </div>
            {/* </a> */}

            {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="#">Home</a> 
                    </li>
                </ul>
            </div> */}
        </div>
    </nav>
}